<template>
    <div class="container h-100">
        <div class="header">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>系统设置</el-breadcrumb-item>
                <el-breadcrumb-item>基础配置</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="tableCon">
          <el-card style="width: 600px">
            <el-form :model="form" :rules="rules" ref="form" label-width="100px" :inline="true">
              <el-form-item label="税点" prop="tax_point" >
                <el-input v-model="form.tax_point" placeholder="请输入税点"
                          @input="changeNum('tax_point')" clearable>
                  <!--                            <span slot="suffix">%</span>-->
                  <span slot="append">%</span>
                </el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="submit()">保存</el-button>
              </el-form-item>
            </el-form>
          </el-card>

        </div>
    </div>
</template>

<script>
import {systemSettingList, systemSettingStore} from '@/api/systemSetting'

export default {
    name: "sysSetting",
    components: {},
    data() {
        return {
            form: {
                tax_point: 0,
                a: 0,
            },
            rules: {
                tax_point: {required: true, message: '请输入税点', trigger: 'blur'},
            }
        }
    },
    created() {
        this.getList();
    },
    methods: {
        getList() {
            systemSettingList().then(res => {
                this.form = Array.isArray(res.model) ? {tax_point: 6} : res.model;
            })
        },

        submit() {
            let that = this;
            that.$refs['form'].validate((valid) => {
                if (valid) {
                  // eslint-disable-next-line
                    systemSettingStore({data: that.form}).then((res) => {
                        that.dialogRole = false;
                        that.showToast({
                            h: that,
                            text: '保存成功'
                        });
                    })
                } else {
                    return false;
                }
            });
        },
        changeNum(field) {
            this.form[field] = this.dealNumber(this.form[field], 4)
        },
        dealNumber(value, digit = 2) {
            value = value.replace(/[^\d.]/g, ""); //清除“数字”和“.”以外的字符
            value = value.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
            value = value.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
            if (digit == 4) {
              // eslint-disable-next-line
                value = value.replace(/^(\-)*(\d+)\.(\d\d\d\d).*$/, '$1$2.$3'); //只能输入四位小数
            } else {
              // eslint-disable-next-line
                value = value.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3'); //只能输入两个小数
            }
            if (value.indexOf(".") < 0 && value != "") { //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
                value = parseFloat(value);
            }
            return value
        }
    }
};
</script>

<style scoped>

.header, .tableCon {
    background: #fff;
    padding: 24px 30px 0 30px;
}

.demo-table-expand label {
    width: 90px;
    color: #99a9bf;
}

.demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
}
</style>
<style>

</style>
